







import { Component, Vue, Prop } from 'vue-property-decorator'
import { StepKeys } from '../variables/ACF_Key'
import { mapState } from 'vuex'
import Menu from '../components/Menu.vue'
@Component({
  components: {
    Menu
  },
  computed: {
    ...mapState({
      responseACF: 'acfApi'
    })
  }
})
export default class Wizard extends Vue {
     @Prop() public step!: number
    // Datas de la vue :
    public ready = false
    // Datas a transmettre au menu :
    public menu: string[] = []
    /** ** Si + d'étapes, les ajouter ici ... */

    //* ************ <!>IMPORTANT<!> -> Object pour enregistrer le JSON récupéré par AXIOS
    public responseACF!: Record<string, string>

    sortACFForThisView (): void{
      // Appel la class permettant de lire le trie du JSON (API WP)
      const menuInfo = new StepKeys(this.responseACF)
      if (menuInfo) {
        // Ajouter la clef ACF des items de la vue
        /***
         * INFO si dessous à modifier celon le projet :
         */
        const item1 = menuInfo.getSimpleValue('you_are_title_menu')
        const item2 = menuInfo.getSimpleValue('your_project_title_menu')
        const item3 = menuInfo.getSimpleValue('it_was_a_title_menu')
        const item4 = menuInfo.getSimpleValue('work_type_title_menu')
        const item5 = menuInfo.getSimpleValue('work_pro_title_menu')
        const item7 = menuInfo.getSimpleValue('form_title_menu')
        this.menu.push(item1, item2, item3, item4, item5, item7)
        /**
         * Sauvegarde les données du menu dans le VUEX
         */
        if (this.menu.length > 0) {
          this.$store.dispatch('saveMenu', this.menu)
        }
        this.ready = true
        this.$emit('childToParent', this.ready)
      }
    }

    /***
     * VUE STATE =>
     */
    mounted (): void {
      //* ** SI le menu existe déja, on transmet les données */
      const haveMenu = this.$store.getters.getMenu
      if (haveMenu.length > 0) {
        this.menu = this.$store.getters.getMenu
        this.ready = true
      } else {
        //* *** Sinon on le créer avec l'API WP */
        this.$store.dispatch('LoadAllACF').then((data) => {
          if (data != null) {
            this.sortACFForThisView()
          }
        })
      }
    }
}
